const createFooter = (receipts, order) => {
  const parts = [];

  // Add QR code if enabled in settings
  if (receipts?.qr_code) {
    try {
      // Check if the QR code exists and what format it's in
      let qrCodeUrl;
      
      if (order.qr_code) {
        // Direct SVG base64 from API - common format from the backend
        const isBase64Image = order.qr_code.startsWith('data:image');
        // URL to an external QR code service
        const isExternalUrl = order.qr_code.startsWith('http://') || order.qr_code.startsWith('https://');
        
        if (isBase64Image || isExternalUrl) {
          qrCodeUrl = order.qr_code;
        } else {
          // Unexpected format, try to base64 encode it in case it's raw SVG or other content
          qrCodeUrl = order.qr_code;
        }
      } else {
        // No QR code found, generate a fallback
        qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=ORDER-${order.order_number || order.id || 'unknown'}`;
      }
    
      parts.push(`
        <div style="text-align: center; margin: 4mm 0;">
          <img 
            src="${qrCodeUrl}" 
            alt="QR Code" 
            style="width: 40mm; height: 40mm; display: inline-block;"
          />
          <div style="font-size: 8pt; margin-top: 2mm;">ORDER #${order.order_number || order.id || ''}</div>
        </div>
      `);
    } catch (error) {
      console.error('Error adding QR code to receipt:', error);
      // If there's an error, add a text note instead
      parts.push(`
        <div style="text-align: center; margin: 4mm 0;">
          <div style="font-size: 8pt;">ORDER #${order.order_number || order.id || ''}</div>
        </div>
      `);
    }
  }

  // Add footer text if available
  if (receipts.footer_text) {
    parts.push(`
      <div style="text-align: center; margin: 3mm 0;">
        <div style="font-size: 8pt; line-height: 1.3;">${receipts.footer_text}</div>
      </div>
    `);
  }

  // Add a bit of padding at the bottom for cutting
  parts.push(`
    <div style="margin-bottom: 8mm;"></div>
  `);

  return parts.join('');
};

export default createFooter;
